import Base from "@/core/base/BaseFilter";
export default class Filter extends Base {
  Id: 0;
  pti: 0;
  dti: 0;
  DateFrom: "";
  DateTo: "";
  IsDeleted: 0;
}
